import { AddCircle, Delete, Edit, Menu, MoreVert, Refresh, Visibility, VisibilityOff } from "@mui/icons-material";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, InputLabel, List, ListItem, MenuItem, Popover, Select, Slide, Stack, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { apiEndpoints, appConfigs } from "../../constants/ApplicationConstants";
import { getRequest, postRequest } from "../../utils/ApiUtil";
import { addAdminMenuToStore, deleteAdminMenuFromStore, editAdminMenuToStore, storeAdminMenu, toggleAdminMenuInStore } from "../../store/AdminMenuStore";
import { setPageMessage, setProcessing } from "../../store/ApplicationStore";
import MenuSerializer from "../../serializers/MenuSerializer";
import PopupState, { bindPopover, bindTrigger } from "material-ui-popup-state";
import { pageMessages } from "../../constants/MessageConstants";
import { useHandleError } from "../others/ErrorScreen";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function ProcessManagerScreen(){
    const { adminmenu } = useSelector(state => state.adminmenu);
    const [ selectedDomain, setSelectedDomain ] = useState("");
    const [ showAddpop, setShowAddpop ] = useState(false);
    const [ addparameters, setAddParameters ] = useState(null);
    const [ showEditpop, setShowEditpop ] = useState(false);
    const [ menuName, setMenuName ] = useState("");
    const [ menuNameCharCount, setMenuNameCharCount ] = useState(appConfigs.menuCharcount);
    const [ menuSelection, setMenuSelection ] = useState(null);
    const [ showHideDeletepop, setShowHideDeletepop ] = useState(0);
    const [ actionFlag, setActionFlag ] = useState(null);

    const dispatch= useDispatch();
    const handleError=useHandleError()

    async function fetchAdminMenus(){
        try{
            dispatch(setProcessing(true));
            const response = await getRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.adminmenu);
            if(response.isError){
                dispatch(setProcessing(false));
                dispatch(setPageMessage({message: response.message, type: "error"}));
            }else{
                const fetchedMenus= response.data&&response.data.map((menu)=>{
                    return MenuSerializer(menu)
                }).filter(obj=>obj)
                dispatch(storeAdminMenu(fetchedMenus)); setSelectedDomain("");
                dispatch(setPageMessage({message: response.message, type: "success"}));
                dispatch(setProcessing(false))
            }
        }catch(err){
            handleError(err)
        }    
    }

    function handleDomainChange(e){
        setSelectedDomain(e.target.value);
    }
    function handleAddToggle(level, origin, parent){
        if(showAddpop){
            setAddParameters(null); setShowAddpop(false); setMenuName(""); setMenuNameCharCount(appConfigs.menuCharcount)
        }else{
            setAddParameters({level_id: level, domain_id: origin, parent_menu_id: parent}); setShowAddpop(true); setMenuNameCharCount(appConfigs.menuCharcount)
        }
    }
    function handleEditToggle(menu){
        if(showEditpop){
            setShowEditpop(false); setMenuName(""); setMenuSelection(null); 
            setMenuNameCharCount(appConfigs.menuCharcount)
        }else{
            setShowEditpop(true); setMenuName(adminmenu.find(item => item.id === menu)&&adminmenu.find(item => item.id === menu).name); setMenuSelection(menu); 
            setMenuNameCharCount(appConfigs.menuCharcount-menuName)
        }
    }
    function handleHideDeleteToggle(menu, isDelete){
        if(showHideDeletepop !== 0){
            setShowHideDeletepop(0); setMenuSelection(null); setActionFlag(null);
        }else{
            if(isDelete){
                setShowHideDeletepop(1); setMenuSelection(menu); setActionFlag(2);
            }else{
                setShowHideDeletepop(2); setMenuSelection(menu); setActionFlag(adminmenu.find(item => item.id === menu)&&adminmenu.find(item => item.id === menu).active?1:0);
            }
        }
    }
    
    async function handleAddSubmit(){
        try{
            dispatch(setProcessing(true));
            if(menuName.trim()===""){
                dispatch(setProcessing(false));
                dispatch(setPageMessage({message: pageMessages.notValidMenuName, type: "error"}));
            }else{
                const request= {...addparameters, menu_name: menuName.trim()};
                const response= await postRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.addMenu, request);
                if(response.isError){
                    dispatch(setProcessing(false));
                    setAddParameters(null); setShowAddpop(false); setMenuName("");
                    dispatch(setPageMessage({message: response.message, type: "error"}));
                }else{
                    dispatch(addAdminMenuToStore(MenuSerializer(response.data)));
                    setAddParameters(null); setShowAddpop(false); setMenuName("");
                    dispatch(setProcessing(false));
                    dispatch(setPageMessage({message: response.message, type: "success"}));
                }
            }
        }catch(err){
            handleError(err)
        }    
    }
    async function handleEditSubmit(){
        try{   
            if(menuName.trim() ==='')
            {           
                dispatch(setPageMessage({message: 'Menu name is empty', type: "error"}));
                return;
            }                   
            if( menuSelection.name !== menuName.trim()){
                dispatch(setProcessing(true));
                const response= await postRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.editMenu, {
                    menu_id: menuSelection,
                    menu_name: menuName.trim(),
                    parent_menu_id: adminmenu.find(item => item.id === menuSelection)&&adminmenu.find(item => item.id === menuSelection).parent
                });
                if(response.isError){
                    dispatch(setProcessing(false));
                    setShowEditpop(false); setMenuName(""); setMenuSelection(null);
                    dispatch(setPageMessage({message: response.message, type: "error"}));
                }else{
                    dispatch(editAdminMenuToStore(MenuSerializer(response.data)));
                    setShowEditpop(false); setMenuName(""); setMenuSelection(null);
                    dispatch(setProcessing(false));
                    dispatch(setPageMessage({message: response.message, type: "success"}));
                }
            }else{            
                dispatch(setPageMessage({message: pageMessages.editmenuNoNameChange, type: "error"}));
            }
        }catch(err){
            handleError(err)
        }  
    }
    async function handleToggleSubmit(){
        try{
            dispatch(setProcessing(true));
            const response= await postRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.hideUnhide, {
                menu_id: menuSelection,
                flag: actionFlag
            });
            if(response.isError){
                dispatch(setProcessing(false));
                setShowHideDeletepop(0); setMenuSelection(null); setActionFlag(null);
                dispatch(setPageMessage({message: response.message, type: "error"}));
            }else{
                dispatch(toggleAdminMenuInStore({data:response.data, flag: actionFlag}));
                setShowHideDeletepop(0); setMenuSelection(null); setActionFlag(null);
                dispatch(setProcessing(false));
                dispatch(setPageMessage({message: response.message, type: "success"}));
            }
        }catch(err){
            handleError(err)
        }      
    }
    async function handleDeleteSubmit(){
        try{
            dispatch(setProcessing(true));
            const response= await postRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.deleteMenu, {
                menu_id: menuSelection
            });
            if(response.isError){
                dispatch(setProcessing(false));
                setShowHideDeletepop(0); setMenuSelection(null); setActionFlag(null);
                dispatch(setPageMessage({message: response.message, type: "error"}));
            }else{
                dispatch(deleteAdminMenuFromStore(response.data));
                const selection=adminmenu.filter(t=>t.id===menuSelection)
                if(selection && selection.length)
                {
                    if(selection[0].parent==='')
                    {
                        setSelectedDomain('')
                    }               
                }
                setShowHideDeletepop(0); setMenuSelection(null); setActionFlag(null); 
                dispatch(setProcessing(false));
                dispatch(setPageMessage({message: response.message, type: "success"}));
            }
        }catch(err){
            handleError(err)
        }  
    }
    return(
        <Box>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Box>
                        <Box display='flex' >                       
                                <Menu sx={{marginRight: '1rem',marginTop:'0.1rem'}}/>
                                <Stack direction='row' alignItems='center'>
                                <Box>
                                    <Typography variant='h5'>Process Manager</Typography>
                                    <Typography sx={{opacity: '0.6'}} variant='subtitle2'>Manage Domains, Processes and SubProcesses.</Typography>
                                </Box>
                                <Refresh onClick={()=>{fetchAdminMenus()}} sx={{marginLeft: '1rem', opacity: 0.6, cursor:'pointer'}} />
                            </Stack>
                        </Box>

                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <Box display="flex" alignItems="center">
                        <Box sx={{cursor: 'pointer'}} display="flex" alignItems="center" onClick={()=>handleAddToggle("L1", "", "")}>
                            <AddCircle sx={{marginRight: '1rem', opacity: '0.8'}} />
                            <Typography sx={{opacity: '0.8'}} variant='subtitle2'>Add Domain</Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={3} sx={{py: '1rem'}}>
                    <Box display="flex">
                        <FormControl size='small' fullWidth>
                            <InputLabel>Select Domain</InputLabel>
                            <Select value={selectedDomain? selectedDomain : ""} label="Select Domain"  onChange={(e)=>handleDomainChange(e)}>
                                {adminmenu&&adminmenu.filter(item=> item.parent === "").map((obj)=>{
                                    return <MenuItem  key={obj.id} value={obj.id}>{obj.active ? obj.name:obj.name+'(hidden)'}</MenuItem>
                                })}
                            </Select>
                        </FormControl>
                        {selectedDomain!==""&&<PopupState variant="popover">
                            {(popupState) => (
                            <>
                                <MoreVert sx={{cursor: 'pointer', margin: 1}} {...bindTrigger(popupState)} />
                                <Popover {...bindPopover(popupState)} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} transformOrigin={{ vertical: 'top', horizontal: 'center' }} >
                                    <List sx={{p: 2}}>
                                        <ListItem disableGutters sx={{cursor: "pointer"}} onClick={()=> {handleEditToggle(selectedDomain); popupState.close()}}>
                                            <Box display="flex" alignItems="center">
                                                <Edit sx={{ marginRight: '1rem', opacity: "0.5" }} />
                                                <Typography>Edit</Typography>
                                            </Box>
                                        </ListItem>
                                        <ListItem disableGutters sx={{cursor: "pointer"}} onClick={()=> {handleHideDeleteToggle(selectedDomain, false); popupState.close()}}>
                                            <Box display="flex" alignItems="center">
                                                {adminmenu.find(item => item.id === selectedDomain)&&adminmenu.find(item => item.id === selectedDomain).active ?<VisibilityOff sx={{ marginRight: '1rem', opacity: "0.5" }} /> 
                                                    : <Visibility sx={{ marginRight: '1rem', opacity: "0.5" }} />
                                                }
                                                <Typography>{adminmenu.find(item => item.id === selectedDomain)&&adminmenu.find(item => item.id === selectedDomain).active ?"Hide":"Unhide" }</Typography>
                                            </Box>
                                        </ListItem>
                                        <ListItem disableGutters sx={{cursor: "pointer"}} onClick={()=> {handleHideDeleteToggle(selectedDomain, true); popupState.close()}}>
                                            <Box display="flex" alignItems="center">
                                                <Delete sx={{ marginRight: '1rem', opacity: "0.5" }} />
                                                <Typography>Delete</Typography>
                                            </Box>
                                        </ListItem>
                                    </List>
                                </Popover>
                            </>
                            )}
                        </PopupState>}
                    </Box>
                </Grid>
                <Grid item xs={12} sx={{py: '1rem', borderTop: '1px solid lightgrey'}}>
                    <Grid container spacing={2}>
                        {selectedDomain&&<Grid item xs={12}>
                            <Box  display="flex" alignItems="center">
                                <Box component='span' display="flex" alignItems="center"sx={{cursor: 'pointer'}} onClick={()=>handleAddToggle("L2", selectedDomain, selectedDomain)} >
                                    <AddCircle sx={{marginRight: '1rem', opacity: '0.8'}} />
                                    <Typography sx={{opacity: '0.8'}} variant='subtitle2'>Add Process</Typography>
                                </Box>
                             </Box>
                        </Grid>}
                        {adminmenu&&adminmenu.filter(process => selectedDomain !== "" && process.domain === selectedDomain && process.parent === selectedDomain).map((processItem)=>{
                            return<Grid key={processItem.id} item xs={12} sm={6} md={4} lg={4}>
                                <Box>
                                    <Box display="flex">
                                        <Typography fontWeight="bold" color="secondary"
                                         sx={{ textDecoration: processItem.active ? 'none' : 'line-through' }}>{processItem.name}</Typography>
                                        <PopupState variant="popover">
                                            {(popupState) => (
                                            <>
                                                <MoreVert sx={{cursor: 'pointer'}} {...bindTrigger(popupState)} />
                                                <Popover {...bindPopover(popupState)} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} transformOrigin={{ vertical: 'top', horizontal: 'center' }} >
                                                    <List sx={{p: 2}}>
                                                        <ListItem disableGutters sx={{cursor: "pointer"}} onClick={()=> {handleEditToggle(processItem.id) ; popupState.close()}}>
                                                            <Box display="flex" alignItems="center">
                                                                <Edit sx={{ marginRight: '1rem', opacity: "0.5" }} />
                                                                <Typography>Edit</Typography>
                                                            </Box>
                                                        </ListItem>
                                                        <ListItem disableGutters sx={{cursor: "pointer"}} onClick={()=> {handleHideDeleteToggle(processItem.id, false); popupState.close()}}>
                                                            <Box display="flex" alignItems="center">
                                                                {adminmenu.find(item => item.id === processItem.id)&&adminmenu.find(item => item.id === processItem.id).active ?<VisibilityOff sx={{ marginRight: '1rem', opacity: "0.5" }} /> 
                                                                    : <Visibility sx={{ marginRight: '1rem', opacity: "0.5" }} />
                                                                }
                                                                <Typography>{adminmenu.find(item => item.id === processItem.id)&&adminmenu.find(item => item.id === processItem.id).active ?"Hide":"Unhide" }</Typography>
                                                            </Box>
                                                        </ListItem>
                                                        <ListItem disableGutters sx={{cursor: "pointer"}} onClick={()=>{ handleHideDeleteToggle(processItem.id, true); popupState.close()}}>
                                                            <Box display="flex" alignItems="center">
                                                                <Delete sx={{ marginRight: '1rem', opacity: "0.5" }} />
                                                                <Typography>Delete</Typography>
                                                            </Box>
                                                        </ListItem>
                                                    </List>
                                                </Popover>
                                            </>
                                            )}
                                        </PopupState>
                                    </Box>
                                    <List dense={true}>
                                        {adminmenu&&adminmenu.filter(subProcess => subProcess.domain === selectedDomain && subProcess.parent === processItem.id).map((subProcessItem)=>{
                                            return <ListItem key={subProcessItem.id} disableGutters   sx={{ cursor: "pointer", padding: '0' }}>
                                                <Box display="flex" alignItems="center">
                                                    <Typography sx={{opacity: '0.8',textDecoration: subProcessItem.active ? 'none' : 'line-through'}}>{subProcessItem.name}</Typography>
                                                        <PopupState variant="popover">
                                                        {(popupState) => (
                                                        <>
                                                            <MoreVert sx={{cursor: 'pointer', margin: 1}} {...bindTrigger(popupState)} />
                                                            <Popover {...bindPopover(popupState)} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} transformOrigin={{ vertical: 'top', horizontal: 'center' }} >
                                                                <List sx={{p: 2}}>
                                                                    <ListItem disableGutters sx={{cursor: "pointer"}} onClick={()=>{ handleEditToggle(subProcessItem.id); popupState.close()}}>
                                                                        <Box display="flex" alignItems="center">
                                                                            <Edit sx={{ marginRight: '1rem', opacity: "0.5" }} />
                                                                            <Typography>Edit</Typography>
                                                                        </Box>
                                                                    </ListItem>
                                                                    <ListItem disableGutters sx={{cursor: "pointer"}} onClick={()=>{ handleHideDeleteToggle(subProcessItem.id, false); popupState.close()}}>
                                                                        <Box display="flex" alignItems="center">
                                                                            {adminmenu.find(item => item.id === subProcessItem.id)&&adminmenu.find(item => item.id === subProcessItem.id).active ?<VisibilityOff sx={{ marginRight: '1rem', opacity: "0.5" }} /> 
                                                                                : <Visibility sx={{ marginRight: '1rem', opacity: "0.5" }} />
                                                                            }
                                                                            <Typography>{adminmenu.find(item => item.id === subProcessItem.id)&&adminmenu.find(item => item.id === subProcessItem.id).active ?"Hide":"Unhide" }</Typography>
                                                                        </Box>
                                                                    </ListItem>
                                                                    <ListItem disableGutters sx={{cursor: "pointer"}} onClick={()=> {handleHideDeleteToggle(subProcessItem.id, true); popupState.close()}}>
                                                                        <Box display="flex" alignItems="center">
                                                                            <Delete sx={{ marginRight: '1rem', opacity: "0.5" }} />
                                                                            <Typography>Delete</Typography>
                                                                        </Box>
                                                                    </ListItem>
                                                                </List>
                                                            </Popover>
                                                        </>
                                                        )}
                                                    </PopupState>
                                                </Box>
                                            </ListItem>
                                        })}
                                    </List>
                                </Box>
                                <Box display="flex" alignItems="center">
                                    <Box component='span' sx={{cursor: 'pointer'}} display="flex" alignItems="center" onClick={()=>handleAddToggle("L3", selectedDomain, processItem.id)}>
                                        <AddCircle sx={{marginRight: '1rem', opacity: '0.8'}} />
                                        <Typography sx={{opacity: '0.8'}} variant='subtitle2'>Add Subprocess</Typography>
                                    </Box>
                                </Box>
                            </Grid>
                        })}
                    </Grid>
                </Grid>
            </Grid>
            <Dialog fullWidth open={showAddpop} TransitionComponent={Transition} keepMounted onClose={()=>handleAddToggle()}>
                <DialogTitle>Add Menu</DialogTitle>
                <DialogContent>
                    <Box sx={{marginTop: '1rem'}}>
                        <TextField inputProps={{ maxLength: appConfigs.menuCharcount }} size='small' fullWidth  label="Menu Name" variant="outlined" value={menuName} onChange={(e)=>{
                            if(/^[a-zA-Z0-9 ]*$/.test(e.target.value)){
                                setMenuName(e.target.value); 
                                setMenuNameCharCount(appConfigs.menuCharcount - e.target.value.length);
                            }
                        }} />
                        <Typography>{menuNameCharCount !== appConfigs.menuCharcount ? `${menuNameCharCount} characters remaining.` : `Maximum ${appConfigs.menuCharcount} characters are allowed.`}</Typography>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button sx={{ textTransform: 'capitalize' }} variant='outlined' color='primary' onClick={()=>handleAddToggle()}>Cancel</Button>
                    <Button sx={{ textTransform: 'capitalize' }} variant='contained' color='primary' disabled={!(menuName.length <= appConfigs.menuCharcount)} onClick={()=>handleAddSubmit()}>Add Menu</Button>
                </DialogActions>
            </Dialog>
            <Dialog fullWidth open={showEditpop} TransitionComponent={Transition} keepMounted onClose={()=>handleEditToggle()}>
                <DialogTitle>Edit Menu</DialogTitle>
                <DialogContent>
                    <Box sx={{marginTop: '1rem'}}>
                        <TextField inputProps={{ maxLength: appConfigs.menuCharcount }} size='small' fullWidth  label="Menu Name" variant="outlined" value={menuName} onChange={(e)=>{
                            if(/^[a-zA-Z0-9 ]*$/.test(e.target.value)){
                                setMenuName(e.target.value); 
                                setMenuNameCharCount(appConfigs.menuCharcount - e.target.value.length);
                            }
                        }} />
                        <Typography>{menuNameCharCount !== appConfigs.menuCharcount ? `${menuNameCharCount} characters remaining.` : `Maximum ${appConfigs.menuCharcount} characters are allowed.`}</Typography>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button sx={{ textTransform: 'capitalize' }} variant='outlined' color='primary' onClick={()=>handleEditToggle()}>Cancel</Button>
                    <Button sx={{ textTransform: 'capitalize' }} variant='contained' color='primary' disabled={!(menuName.length <= appConfigs.menuCharcount)} onClick={()=>handleEditSubmit()}>Edit Menu</Button>
                </DialogActions>
            </Dialog>
            <Dialog fullWidth open={showHideDeletepop!==0} TransitionComponent={Transition} keepMounted onClose={()=>handleHideDeleteToggle()}>
                <DialogTitle>{actionFlag===2 ? "Delete Menu" : actionFlag === 0 ? "Unhide Menu" : "Hide Menu"}</DialogTitle>
                <DialogContent>
                    <Box sx={{marginTop: '1rem'}}>
                        <Typography>
                            {actionFlag===2&& "This action will delete the menu and it's associated child menus. Are you sure you want to proceed ?"}
                            {actionFlag===0&& "This action will unhide the menu and it's associated child menus. Are you sure you want to proceed ?"}
                            {actionFlag===1&& "This action will hide the menu and it's associated child menus. Are you sure you want to proceed ?"}
                        </Typography>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button sx={{ textTransform: 'capitalize' }} variant='outlined' color='primary' onClick={()=>handleHideDeleteToggle()}>Cancel</Button>
                    <Button sx={{ textTransform: 'capitalize' }} variant='contained' color='primary' onClick={()=>actionFlag===2?handleDeleteSubmit():handleToggleSubmit()}>{actionFlag===2 ? "Delete Menu" : actionFlag === 0 ? "Unhide Menu" : "Hide Menu"}</Button>
                </DialogActions>
            </Dialog>
        </Box>

    )
}